export default "__VITE_ASSET__VyiAJYNH__"